import { supabase } from './supabase'

const GCS_BUCKET_URL = 'https://storage.googleapis.com/trainingmatrix'

export function gcsGetPublicUrl(filePath) {
  return `${GCS_BUCKET_URL}/${filePath}`
}

export async function gcsUploadFile(file, { folderPath, fileName, contentType }) {
  const safeName = fileName || file.name
  const safeContentType = contentType || file.type || 'application/octet-stream'

  const { data: urlData, error: urlError } = await supabase.functions.invoke(
    'generate-upload-url',
    {
      body: {
        fileName: safeName,
        contentType: safeContentType,
        folderPath,
      },
    }
  )

  if (urlError || !urlData?.signedUrl) {
    throw new Error(urlError?.message || 'Failed to get upload URL')
  }

  const uploadRes = await fetch(urlData.signedUrl, {
    method: 'PUT',
    headers: { 'Content-Type': safeContentType },
    body: file,
  })

  if (!uploadRes.ok) {
    throw new Error(`Upload failed with status ${uploadRes.status}`)
  }

  return {
    publicUrl: urlData.publicUrl,
    filePath: urlData.fileName,
  }
}
